<script>
  import { External, M } from '../external';
  import { planValueToStr } from './Addons/addons';

  export let subscription;

  let planUsage = (key, showMoreThan999AsUnlimited) => {
    let value = '';
    let unit = { 'bandwidth': 'GB', 'storage': 'GB' }[key] || '';
    let limit = subscription.planDetails[key];
    if (External.isUndefined(limit)) {
      return '-';
    }

    let usage = subscription.planUsage[key];
    if (!External.isUndefined(usage)) {
      value = `${planValueToStr(usage, key)} ${M.OF} `;
    }

    if (showMoreThan999AsUnlimited && limit >= 999 || !showMoreThan999AsUnlimited && limit === 999) {
      value += M.UNLIMITED;
    } else {
      value += (limit + unit);
    }
    return value;
  };
</script>
<div class="scrollable-table orders-scrollable-table mt-25 f-left half-half-table">
  <table style="margin-top: 0;">
    <thead>
    <tr class="flex flex-row align-center" style="padding-bottom: 0;">
      <th class="flex-none"><a>{M.RESOURCE}</a></th>
      <th class="flex-1"><a>{M.LIMIT}</a></th>
    </tr>
    </thead>
    <tbody style="height: auto;">
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.WEBSITES}</td>
      <td class="flex-1">{planUsage('websites', true)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.FUNNELS}</td>
      <td class="flex-1">{planUsage('funnels', true)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.TRAFFIC}</td>
      <td class="flex-1">{planUsage('bandwidth', false)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.STORAGE}</td>
      <td class="flex-1">{planUsage('storage', true)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.PAGES}</td>
      <td class="flex-1">{planUsage('pages', true)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.PRODUCTS}</td>
      <td class="flex-1">{planUsage('storeProducts', true)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.BOOKING_OPERATORS}</td>
      <td class="flex-1">{planUsage('bookingOperators', false)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.ADMINS}</td>
      <td class="flex-1">{planUsage('contributors', false)}
      </td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.MARKETING_SUBSCRIBERS}</td>
      <td class="flex-1">{planUsage('marketingSubscribers', false)}</td>
    </tr>
    <tr class="flex flex-row align-center">
      <td class="flex-none">{M.EMAILS_SENT}</td>
      <td class="flex-1">{planUsage('sentEmails', false)}</td>
    </tr>
    {#if !External.Website.communityFeaturesDisabled}
      <tr class="flex flex-row align-center">
        <td class="flex-none">{M.CIRCLES}</td>
        <td class="flex-1">{planUsage('circles', true)}</td>
      </tr>
      <tr class="flex flex-row align-center">
        <td class="flex-none">{M.CRICLE_MEMBERS}</td>
        <td class="flex-1">{planUsage('circleMembers', false)}</td>
      </tr>
    {/if}
    {#if !External.Website.videoFeaturesDisabled}
      <tr class="flex flex-row align-center">
        <td class="flex-none">{M.VIDEOS}</td>
        <td class="flex-1">{planUsage('videos', false)}</td>
      </tr>
    {/if}
    <!--
    <tr class="flex flex-row align-center">
      <td class="flex-none">Video Minutes</td>
      <td class="flex-1">{planUsage('videoMinutes', false)}</td>
    </tr>
    
    <tr class="flex flex-row align-center">
      <td class="flex-none">E-Commerce Affiliate</td>
      <td class="flex-1"><a href="" class="middle-button blue with-icon">Enable</a></td>
    </tr>
    -->
    </tbody>
  </table>
</div>
<span class="light-gray-text col20 f-left mt-10 mb-25">
  {External.format(M.USAGE_RESET, 'x', External.Tools.dateToString(External.Tools.ddmmyyStringToDate(subscription.planUsage.usageResetDate)))}
</span>
